import React from 'react'

import { RootChartConfigObject } from '../../../types/shared'
import { NotificationWrapper } from '../../components'
import { ElementStyleDialogWrapper } from '../../modals/element_style'
import { useAsyncModule, withSuspense } from '../../utils/async-modules-utils'
import { chartSettingsAsyncModule } from '../chart-settings/async-modules'
import { ChartLayoutComponent } from './chart_layout_component'

interface ChartLayoutProps {
  config: RootChartConfigObject
  shouldResize?: boolean
  parentElement?: HTMLElement
  isWithNotifications?: boolean
}

export function ChartLayout({ config, shouldResize, isWithNotifications = true }: ChartLayoutProps) {
  const Wrapper = isWithNotifications ? NotificationWrapper : React.Fragment
  return (
    <Wrapper>
      <ElementStyleDialogWrapper>
        <ChartLayoutComponent config={config} shouldResize={shouldResize} />
      </ElementStyleDialogWrapper>
    </Wrapper>
  )
}

export function ChartLayoutWithGlobalStateRaw({
  config,
  shouldResize,
  parentElement,
}: Omit<ChartLayoutProps, 'isWithNotifications'>) {
  const [chartsModule] = useAsyncModule({
    ...chartSettingsAsyncModule,
    isSuspenseMode: true,
  })
  const { setChartLayoutModel, getChartLayoutModelConfig, lastGlobalRerender } =
    chartsModule.useChartLayoutGlobalModel()

  return (
    <ElementStyleDialogWrapper>
      {config && (
        <ChartLayoutComponent
          key={lastGlobalRerender}
          config={getChartLayoutModelConfig({ fallback: config })}
          shouldResize={shouldResize}
          onRegisterChartLayoutModel={setChartLayoutModel}
          parentElement={parentElement}
        />
      )}
    </ElementStyleDialogWrapper>
  )
}

export const ChartLayoutWithGlobalState = withSuspense(ChartLayoutWithGlobalStateRaw)
